<template>
  <div>
    <div class="se-die-bet-lot-cell" :class="{ 'se-die-bet-lot-cell-active': win, [size]: size }">
      <div
        class="se-die-bet-lot-title"
        :class="{ [size]: size }"
        type="flex"
        justify="center"
        align="middle"
      >
        <span v-html="$t(`sedie.${type}`)"></span>
      </div>
      <div
        class="se-die-bet-lot-bet-no"
        :class="{ [size]: size }"
        type="flex"
        justify="center"
      >{{ odd }}</div>
      <div v-if="stakeRecordSum" class="se-die-bet-lot-stake-total">{{ stakeRecord }}</div>
    </div>
  </div>
</template>

<script>
import { Row } from "iview";
import { snakeCase } from "change-case";

export default {
  props: ["type", "odd", "win", "game", "size", "stakeRecordSum"],
  components: {
    Row
  },
  computed: {
    gameSnakeCase() {
      return snakeCase(this.game);
    },
    stakeRecord() {
      return display_numeric(this.stakeRecordSum);
    }
  }
};
</script>

<style lang="scss" scoped>
.rangetxt {
  color: #999;
  font-size: 8px;
  display: inline-block;
  text-align: center;
  position: absolute;
  right: 2px;
  top: 2px;
}
.open-result .se-die-bet-lot-cell-active {
  background: linear-gradient(to right, #1a6dbc, #52b2ff);
  color: #fff;
}

.open-result .se-die-bet-lot-cell-active .se-die-bet-lot-title,
.open-result .se-die-bet-lot-cell-active .se-die-bet-lot-bet-no {
  color: #fff;
  opacity: 1;
}

.se-die-bet-lot-cell {
  width: 100%;
  text-align: center;
  padding: 5px 0;
  position: relative;
}

.se-die-bet-lot-cell.small {
  padding-top: 10px;
  padding-bottom: 6px;
}

.se-die-bet-lot-cell:first-of-type {
  margin-left: unset;
}

.se-die-bet-lot-cell:last-of-type {
  margin-right: unset;
}

.se-die-bet-lot-title {
  text-align: center;
  font-weight: 600;
  font-size: 12px;
  color: #000;
}

.se-die-bet-lot-title.small {
  height: unset;
  margin-top: 5px;
}

.se-die-bet-lot-cell.middle {
  line-height: 50px;
}

.se-die-bet-lot-bet-no {
  @extend .tai-xiu-game-bet-no;
  margin-top: 0px;
  color: #999;
  font-size: 10px;
  font-weight: bold;
}
</style>

<style lang="scss">
.se-die-bet-lot-cell {
  @extend .tai-xiu-game-btn;
}

.se-die-bet-lot-cell.se-die-bet-lot-cell-active .se-die-bet-lot-title {
  color: #b53f39;
}

.se-die-bet-lot-stake-total {
  display: flex;
  align-items: center;
  position: absolute;
  top: 0;
  right: 0;
  text-align: center;
  font-weight: bold;
  font-size: 11px;
  padding: 5px;
  background: $tai-xiu-theme-color-3;
  color: $tai-xiu-theme-color-5;
  border-bottom-left-radius: 8px;
  max-height: 16px;
  line-height: 16px;
}

@media only screen and (max-width: 360px) {
  .se-die-bet-lot-cell {
    padding: 6px 0;
  }

  .se-die-bet-lot-cell.large {
    padding-bottom: 6px;
  }
}
</style>
